import { DeleteSharp, EditSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  insertBlueTickRejectReason,
  updateBlueTickRejectReason,
  deleteBlueTickRejectReason,
  getBlueTickRejectReason
} from "src/api/commonapi";
import Page from "src/components/Page";
import { notification } from "src/utils/messages";
import Deletemodal from "./DeleteModal";
import CustomLoader from "src/commonComponents/CustomLoader";

export default function BlueTickRejectReason() {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [addEditModal, setAddEditModal] = useState(false);
  const [blueTickRejectReasonData, setBlueTickRejectReasonData] = useState({
    bluetick_reject_reason: ""
  });
  const [tableData, setTableData] = useState([]);
  const toggleAddEditModal = () => setAddEditModal(!addEditModal);
  const resetFormData = () => {
    setBlueTickRejectReasonData({
      bluetick_reject_reason: ""
    });
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [response, setresponse] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (newData = undefined) => {
    if (newData != undefined ? newData : blueTickRejectReasonData.bluetick_r_id != undefined) {
      // update
      if (
        (newData != undefined ? newData : blueTickRejectReasonData).bluetick_reject_reason != ""
      ) {
        let fnData = new FormData();
        fnData.append(
          "bluetick_r_id",
          newData != undefined ? newData.bluetick_r_id : blueTickRejectReasonData.bluetick_r_id
        );
        fnData.append(
          "bluetick_reject_reason",
          newData != undefined
            ? newData.bluetick_reject_reason
            : blueTickRejectReasonData.bluetick_reject_reason
        );

        setIsLoading(true);
        let resp = await updateBlueTickRejectReason(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          newData == undefined && toggleAddEditModal();
          getBlueTickRejectReasonData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    } else {
      // Insert
      if (blueTickRejectReasonData.bluetick_reject_reason != "") {
        let fnData = new FormData();
        fnData.append("bluetick_reject_reason", blueTickRejectReasonData.bluetick_reject_reason);
        setIsLoading(true);
        let resp = await insertBlueTickRejectReason(fnData);
        setIsLoading(false);
        if (resp.status != 0) {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
          resetFormData();
          toggleAddEditModal();
          getBlueTickRejectReasonData();
        } else {
          let notify = notification({
            type: resp.status == 0 ? "error" : "success",
            message: resp.message
          });
          notify();
        }
      } else {
        let notify = notification({
          type: "error",
          message: "Please Fill All Fields data"
        });
        notify();
      }
    }
  };
  const deleteBlueTickRejectReasons = async (bluetick_r_id) => {
    const resp = await deleteBlueTickRejectReason(bluetick_r_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();

    if (resp.status == 1) {
      setresponse(response + 1);
      setDvisible({ mval: false, id: 0 });
    }
  };
  const getBlueTickRejectReasonData = async () => {
    setIsLoading(true);
    let res = await getBlueTickRejectReason();
    setIsLoading(false);
    setTableData(res);
  };
  useEffect(() => {
    getBlueTickRejectReasonData();
  }, [response]);

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row) => row?.bluetick_r_id,
      sortable: true,
      width: "100px"
    },
    {
      name: "Name",
      wrap: true,
      selector: (row) => row?.bluetick_reject_reason,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      sortable: true,
      selector: (row) => (
        <>
          {row.bluetick_r_id != 1 && (
            <>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() => {
                    setBlueTickRejectReasonData({
                      bluetick_reject_reason: row.bluetick_reject_reason,
                      bluetick_r_id: row.bluetick_r_id
                    });
                    toggleAddEditModal();
                  }}
                >
                  <EditSharp color="warning" />
                </IconButton>
              </Tooltip>

              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setDvisible({ mval: true, id: row.bluetick_r_id });
                  }}
                >
                  <DeleteSharp color="error" />
                </IconButton>
              </Tooltip>
            </>
          )}
        </>
      )
    }
  ];

  return (
    <>
      <Deletemodal
        visible={dvisible}
        setVisible={setDvisible}
        deletefunc={deleteBlueTickRejectReasons}
      />

      <Page title="LVB BlueTick Reject Reasons | Local Vocal Business Group">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h4" gutterBottom>
                  BlueTick Reject Reasons
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={() => (toggleAddEditModal(), resetFormData())}
                style={{ marginBottom: "15px", float: "right" }}
                variant="contained"
              >
                Add BlueTick Reject Reasons
              </Button>
            </Grid>
          </Grid>

          <Modal
            open={addEditModal}
            onClose={() => (toggleAddEditModal(), resetFormData())}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Add BlueTick Reject Reason
              </Typography>
              <hr />
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Grid container>
                  <Grid item sm={12} xs={12}>
                    <TextField
                      style={{ marginTop: "15px" }}
                      height={10}
                      fullWidth
                      autoComplete="off"
                      type="text"
                      label="BlueTick Reject Reason"
                      name="bluetick_reject_reason"
                      placeholder="Enter BlueTick Reject Reason"
                      onChange={(e) => {
                        setBlueTickRejectReasonData({
                          ...blueTickRejectReasonData,
                          bluetick_reject_reason: e.target.value
                        });
                      }}
                      value={blueTickRejectReasonData?.bluetick_reject_reason}
                    />
                  </Grid>
                  <Grid
                    item
                    sm={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={() => (toggleAddEditModal(), resetFormData())}
                      style={{ marginTop: "15px", marginRight: "15px" }}
                    >
                      Close
                    </Button>
                    <Button
                      variant="contained"
                      style={{ marginTop: "15px" }}
                      onClick={() => handleSubmit()}
                      disabled={isLoading}
                      startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Modal>

          <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
            <DataTable
              filter
              pagination
              highlightOnHover
              columns={columns}
              data={tableData != null ? tableData : []}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
            />
          </Card>
        </Container>
      </Page>
    </>
  );
}
